var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -542 -400 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 549.5 401  C 553.14 401  556 403.86  556 407.5  C 556 411.14  553.14 414  549.5 414  C 545.86 414  543 411.14  543 407.5  C 543 403.86  545.86 401  549.5 401  Z ",
    fillRule: "nonzero",
    fill: "#fdfdfd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 549.5 401  C 553.14 401  556 403.86  556 407.5  C 556 411.14  553.14 414  549.5 414  C 545.86 414  543 411.14  543 407.5  C 543 403.86  545.86 401  549.5 401  Z ",
    strokeWidth: 2,
    stroke: "#460074",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartCircle);
export default __webpack_public_path__ + "static/media/chartCircle.a1148b0e7112cc2d3086230ba5669466.svg";
export { ForwardRef as ReactComponent };